import { AccountTripForUser } from '../../models';
import { buildTripAccessContext } from '../trip-access/build-trip-access-context';

export function isCoffeeFundraisingAllowed(
  trip: AccountTripForUser | null | undefined,
): boolean {
  const access = buildTripAccessContext(trip);
  if (!access) {
    return false;
  }
  return access.isLead && access.isStandardTrip;
}
